module.exports = __webpack_public_path__ + "static/media/Vis.bb18a0cf.svg";